import axios from 'axios';
import {
    clearAuthStorage,
    getAccessToken,
    isAccessTokenExpired,
    removeAccessToken,
    setAccessToken
} from '../features/auth/authStorage';

const api = axios.create({
    baseURL: process.env.REACT_APP_API_BASE_URL,
    headers: {
        'Content-Type': 'application/json',
    },
    withCredentials: true,
    timeout: 5000,
});

api.interceptors.request.use(
    (config) => {
        const token = getAccessToken();

        if (token && isAccessTokenExpired(token)) {
            removeAccessToken();
            return config;
        }

        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }

        return config;
    },
    (error) => Promise.reject(error)
);

api.interceptors.response.use(
    (response) => response,
    async (error) => {
        const originalRequest = error.config;

        if (error.response?.status === 401 && originalRequest && !originalRequest._retry) {
            originalRequest._retry = true;

            try {
                const refreshResponse = await axios.post(
                    `${process.env.REACT_APP_API_BASE_URL}/api/v1/auth/refresh`,
                    {},
                    {withCredentials: true}
                );

                const newAccessToken = refreshResponse.data.accessToken;
                setAccessToken(newAccessToken);

                originalRequest.headers = originalRequest.headers ?? {};
                originalRequest.headers.Authorization = `Bearer ${newAccessToken}`;
                return api(originalRequest);
            } catch (refreshError) {
                clearAuthStorage();
                alert('로그인이 만료되었습니다. 다시 로그인해 주세요.');
                window.location.href = '/';

                return Promise.reject(refreshError);
            }
        }

        return Promise.reject(error);
    }
);

export default api;
